import { CustomerEndpoint } from '@dato-proxy/endpoints/customer.endpoint';
import { ServiceBagService, ServiceBagServices } from '@m4u-angular/base/component/ServiceBag';
import { PaymentRequest } from '@dato-proxy/entities/paymentrequest.entity';
import { BaseEntityResponse, BaseState } from '@m4u-angular/base/entities/BaseEntities';
import { BasePageComponent } from '@m4u-angular/base/component/BasePageComponent';
import { ChangeDetectorRef, Component, ElementRef, ViewChild } from '@angular/core';
import { EnumPageDisplayModes } from '@m4u-angular/core/framework/sysenums.enum';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { PageLayoutComponent } from '@m4u-angular/ui/layouts/layout/page-layout/pagelayout.component';

class State extends BaseState
{
    Url: SafeResourceUrl;
}

@Component({
    providers: ServiceBagServices,
    selector: 'app-change-credit-card-dialog',
    templateUrl: './change-credit-card-dialog.component.html',
    styleUrls: ['./change-credit-card-dialog.component.scss']
})
export class ChangeCreditCardDialogComponent extends BasePageComponent<PaymentRequest, State> {

    @ViewChild('page') pageLayout: PageLayoutComponent;
    @ViewChild('iframe') iframe: ElementRef;

    constructor(A: ServiceBagService,
        private customerEndpoint: CustomerEndpoint,
        private Sanitizer: DomSanitizer,
        private ref: ChangeDetectorRef) {
        super(A, 'ChangeCreditCardDialogComponent', PaymentRequest, State, EnumPageDisplayModes.Dialog);
    }

    override OnInitComponent() {

        this.Do(this.customerEndpoint.ChangeCreditCardRequest(), false, (response: BaseEntityResponse<PaymentRequest>) => {
            this.State.Url = this.Sanitizer.bypassSecurityTrustResourceUrl(response.Entity.Url);
            this.Repaint();
        });

        (window.document as any).OnSuccessfulPayment = (PrivateRequestID: string) => {
            this.OnSuccessfulPaymentHandler(PrivateRequestID);
        };

        (window.document as any).OnBackPayment = () => {
            this.OnBackPaymentHandler();
        };

        window.onmessage = (event: any) => {
            if (event.data.type && event.data.type == "OnHeightChanged") {
                this.ResizeIframe(event.data.height);
            }
        };
    }

    protected override OnInitComponentFinished(): void {
        this.Repaint();
    }

    private OnSuccessfulPaymentHandler(PrivateRequestID: string) {
        this.Do(this.customerEndpoint.ConfirmChangeCreditCardRequest(PrivateRequestID), false, () => {
            this.CloseDialogWithSuccess();
            this.ref.detectChanges();
        });
    }

    private OnBackPaymentHandler() {
        this.CloseDialogWithCancel();
    }

    ResizeIframe = (iframeHeight: number) => {
        if (iframeHeight == null || iframeHeight == 0) return;
        const iframeHeightPx = `${iframeHeight}px`;

        const popupInstance = this.pageLayout?.popup?.instance;
        if (popupInstance) {
            this.iframe.nativeElement.style.height = iframeHeightPx;

            const iframeRect = document.querySelector(`.${this.pageLayout.Class} iframe`).getBoundingClientRect();
            const iframeTop = iframeRect.top;

            const popupTop = popupInstance.content().getBoundingClientRect().top;
            const popupPadding = +window.getComputedStyle(document.querySelector(`.${this.pageLayout.Class} .${popupInstance.content().classList[0]} .page-body`))
                .padding.replace('px', '');
    
            const newPopupHeight = iframeTop - popupTop + iframeHeight + popupPadding;
            popupInstance.option('height', newPopupHeight);
            this.Repaint();
        } else {
            const iframes = document.querySelectorAll('.sheet-content iframe');
            const iframe = iframes.length && iframes[iframes.length - 1] as any;

            iframe && (iframe.style.height = iframeHeightPx);
        }
    }

    Repaint() {
        setTimeout(() => this.pageLayout?.popup?.instance?.repaint());
    }
}
